import ApiHttp from '../http';

class AdumoService {
    /**
     * Service for submitting a subscription form to Adumo
     */
    constructor() {
    }

    prepareSubscription(user) {
        if (!user) throw Error('User no defined')
        return ApiHttp.post('/adumo/prepare', user)
    }

    cancelSubscription(id,UserSessionId) {
        if (!id) throw Error('member id is required')
        return ApiHttp.post(`/content/subscription?type=cancelSub&vistaMemberID=${id}&VARIABLE4=${UserSessionId}`)
    }
    
    checkCancelSubscription(id) {
        if (!id) throw Error('member id is required')
        return ApiHttp.post(`/content/subscription?type=cancelSub&vistaMemberID=${id}&check=true`)
    }

    updateCardSubscription(id, card) {
        if (!card) throw Error('member card is required')
        return ApiHttp.post(`/content/subscription?type=updateCard&vistaMemberID=${id}`, card)
    }
    
    updateCardSubscriptionTokens(id) {
        if (!id) throw Error('member id is required')
        return ApiHttp.post(`/content/subscription?type=updateTokens&vistaMemberID=${id}`)
    }
}

export default new AdumoService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/adumo-service.js